import Model from './model.js'

export default class Entry {
    from = 'Unknown'
    to = 'Unknown'

    constructor(historial, options = {}) {
        this.historial = historial
        this.options = options

        this.setFrom()
        this.setTo()

        // console.log(this.historial);

        // console.log({
        //     from: this.from,
        //     to: this.to,
        // })

        delete this.historial
        delete this.options
    }

    setFrom() {
        if (this.options.user.id == this.historial?.created_by?.id) {
            this.from = 'You'
        }

        if (this.historial.created_by != undefined) {
            this.from = this.historial.created_by.first_name;
        }

        if (this.historial.historial.from_belongs != undefined) {
            this.from = this.historial.historial.from_belongs.first_name
        }
    }

    setTo() {
        if (this.options.user.id == this.historial?.for?.id) {
            this.to = 'You'
        }

        if (this.historial.for != undefined) {
            this.to = this.historial.for.first_name
        }

        if (this.historial.for == null && this.options.pageUser != null) {
            this.to = this.options.pageUser.first_name;
        }
    }
}
